import { Place } from '@/types/google-maps.types';
import { toCitySlug } from '@/utils/formatters/city/to-city-slug.util';

export const KNOWN_CITY_PLACES = {
  'curitiba-pr': {
    placeId: 'ChIJ3bPNUVPj3JQRCejLuqVrL20',
    formattedAddress: 'Curitiba, PR, Brasil',
    latitude: -25.4372382,
    longitude: -49.2699727,
    types: ['locality', 'political'],
    city: 'Curitiba',
    state: 'PR',
  },
  'sao-paulo-sp': {
    placeId: 'ChIJ0WGkg4FEzpQRrlsz_whLqZs',
    formattedAddress: 'São Paulo, SP, Brasil',
    latitude: -23.5557714,
    longitude: -46.6395571,
    types: ['locality', 'political'],
    city: 'São Paulo',
    state: 'SP',
  },
  'florianopolis-sc': {
    placeId: 'ChIJ1zLGsk45J5URRscEagtVvIE',
    formattedAddress: 'Florianópolis, SC, Brasil',
    latitude: -27.5948036,
    longitude: -48.5569286,
    types: ['locality', 'political'],
    city: 'Florianópolis',
    state: 'SC',
  },
  'londrina-pr': {
    placeId: 'ChIJbVivV1pD65QRcfkUxqURrCM',
    formattedAddress: 'Londrina, PR, Brasil',
    latitude: -23.3197305,
    longitude: -51.1662008,
    types: ['locality', 'political'],
    city: 'Londrina',
    state: 'PR',
  },
  'maringa-pr': {
    placeId: 'ChIJH4xhQu7W7JQRJTngKChZVsM',
    formattedAddress: 'Maringá, PR, Brasil',
    latitude: -23.4209686,
    longitude: -51.9330844,
    types: ['locality', 'political'],
    city: 'Maringá',
    state: 'PR',
  },
  'ponta-grossa-pr': {
    placeId: 'ChIJISMQX8Ya6JQR8bIpRub0sKw',
    formattedAddress: 'Ponta Grossa, PR, Brasil',
    latitude: -25.0995752,
    longitude: -50.1583959,
    types: ['locality', 'political'],
    city: 'Ponta Grossa',
    state: 'PR',
  },
  'osasco-sp': {
    placeId: 'ChIJB_KeWwj_zpQRTkyCTH3iIQ8',
    formattedAddress: 'Osasco, SP, Brasil',
    latitude: -23.5326334,
    longitude: -46.7915243,
    types: ['locality', 'political'],
    city: 'Osasco',
    state: 'SP',
  },
  'balneario-camboriu-sc': {
    placeId: 'ChIJrSrlwly22JQRxOut5vUEwC0',
    formattedAddress: 'Balneário Camboriú, SC, Brasil',
    latitude: -26.9979839,
    longitude: -48.63258,
    types: ['locality', 'political'],
    city: 'Balneário Camboriú',
    state: 'SC',
  },
  'cascavel-pr': {
    placeId: 'ChIJYU33xx7U85QRvF9a4OwyrOs',
    formattedAddress: 'Cascavel, PR, Brasil',
    latitude: -24.9541715,
    longitude: -53.480283,
    types: ['locality', 'political'],
    city: 'Cascavel',
    state: 'PR',
  },
  'joinville-sc': {
    placeId: 'ChIJN6uxnfOj3pQR-ulh8Z2YS7w',
    formattedAddress: 'Joinville, SC, Brasil',
    latitude: -26.3043758,
    longitude: -48.8463744,
    types: ['locality', 'political'],
    city: 'Joinville',
    state: 'SC',
  },
  'itajai-sc': {
    placeId: 'ChIJO2aUG2XM2JQRezBAlGEtb1A',
    formattedAddress: 'Itajaí, SC, Brasil',
    latitude: -26.9082859,
    longitude: -48.6775167,
    types: ['locality', 'political'],
    city: 'Itajaí',
    state: 'SC',
  },
  'foz-do-iguacu-pr': {
    placeId: 'ChIJQwpTruuQ9pQRUqnEtHOUlyE',
    formattedAddress: 'Foz do Iguaçu, PR, Brasil',
    latitude: -25.5163356,
    longitude: -54.5853764,
    types: ['locality', 'political'],
    city: 'Foz do Iguaçu',
    state: 'PR',
  },
  'camboriu-sc': {
    placeId: 'ChIJ-8VjtNq12JQRbSKy_JNmYRk',
    formattedAddress: 'Camboriú, SC, Brasil',
    latitude: -27.0217451,
    longitude: -48.6515664,
    types: ['locality', 'political'],
    city: 'Camboriú',
    state: 'SC',
  },
  'itapema-sc': {
    placeId: 'ChIJEwTa9Ayx2JQRXHfZmtAgHSM',
    formattedAddress: 'Itapema, SC, Brasil',
    latitude: -27.0909014,
    longitude: -48.6151468,
    types: ['locality', 'political'],
    city: 'Itapema',
    state: 'SC',
  },
  'sao-jose-dos-pinhais-pr': {
    placeId: 'ChIJc3mP0kn23JQRVtbCO71iF_U',
    formattedAddress: 'São José dos Pinhais, PR, Brasil',
    latitude: -25.5345818,
    longitude: -49.2032653,
    types: ['locality', 'political'],
    city: 'São José dos Pinhais',
    state: 'PR',
  },
  'colombo-pr': {
    placeId: 'ChIJX2Yvsxvo3JQRFbd4Dj96onE',
    formattedAddress: 'Colombo, PR, Brasil',
    latitude: -25.3644204,
    longitude: -49.1860165,
    types: ['locality', 'political'],
    city: 'Colombo',
    state: 'PR',
  },
  'pinhais-pr': {
    placeId: 'ChIJgzKoD03u3JQREdNbDhpL-_U',
    formattedAddress: 'Pinhais, PR, Brasil',
    latitude: -25.4323659,
    longitude: -49.1933233,
    types: ['locality', 'political'],
    city: 'Pinhais',
    state: 'PR',
  },
  'fazenda-rio-grande-pr': {
    placeId: 'ChIJ-aExj2T_3JQRFLRvFH1TGQQ',
    formattedAddress: 'Fazenda Rio Grande, PR, Brasil',
    latitude: -25.6484464,
    longitude: -49.3067238,
    types: ['locality', 'political'],
    city: 'Fazenda Rio Grande',
    state: 'PR',
  },
  'araucaria-pr': {
    placeId: 'ChIJa76tTfUC3ZQR9LBk4eDLQLE',
    formattedAddress: 'Araucária, PR, Brasil',
    latitude: -25.5898125,
    longitude: -49.3997714,
    types: ['locality', 'political'],
    city: 'Araucária',
    state: 'PR',
  },
  'piraquara-pr': {
    placeId: 'ChIJ958nlgTz3JQR3XRdCat3hMw',
    formattedAddress: 'Piraquara, PR, Brasil',
    latitude: -25.4475001,
    longitude: -49.0660739,
    types: ['locality', 'political'],
    city: 'Piraquara',
    state: 'PR',
  },
  'campo-largo-pr': {
    placeId: 'ChIJg1hC35IZ3ZQRcUwgnElmFlg',
    formattedAddress: 'Campo Largo, PR, Brasil',
    latitude: -25.4583624,
    longitude: -49.5337119,
    types: ['locality', 'political'],
    city: 'Campo Largo',
    state: 'PR',
  },
  'almirante-tamandare-pr': {
    placeId: 'ChIJG89I0uPe3JQRpz4UanbhSJo',
    formattedAddress: 'Almirante Tamandaré, PR, Brasil',
    latitude: -25.3128146,
    longitude: -49.299609,
    types: ['administrative_area_level_2', 'political'],
    city: 'Almirante Tamandaré',
    state: 'PR',
  },
  'sao-jose-sc': {
    placeId: 'ChIJYV3720VKJ5URYuN_eXDxCxA',
    formattedAddress: 'São José, SC, Brasil',
    latitude: -27.5950396,
    longitude: -48.6137681,
    types: ['locality', 'political'],
    city: 'São José',
    state: 'SC',
  },
  'palhoca-sc': {
    placeId: 'ChIJwSq-1Q4yJ5URBqqQnTsWhz0',
    formattedAddress: 'Palhoça, SC, Brasil',
    latitude: -27.6411215,
    longitude: -48.6789533,
    types: ['locality', 'political'],
    city: 'Palhoça',
    state: 'SC',
  },
  'blumenau-sc': {
    placeId: 'ChIJlTBci0Ae35QRRHYavCCF-6w',
    formattedAddress: 'Blumenau, SC, Brasil',
    latitude: -26.9165792,
    longitude: -49.0717331,
    types: ['locality', 'political'],
    city: 'Blumenau',
    state: 'SC',
  },
  'jaragua-do-sul-sc': {
    placeId: 'ChIJrTXHReyU3pQRVOfxqgtmKNU',
    formattedAddress: 'Jaraguá do Sul, SC, Brasil',
    latitude: -26.4813798,
    longitude: -49.0842138,
    types: ['locality', 'political'],
    city: 'Jaraguá do Sul',
    state: 'SC',
  },
  'palmas-to': {
    placeId: 'ChIJVxIfkTk0O5MRj4Fc0HCAOwk',
    formattedAddress: 'Palmas, TO, Brasil',
    latitude: -10.249091,
    longitude: -48.3242858,
    types: ['locality', 'political'],
    city: 'Palmas',
    state: 'TO',
  },
  'teresina-pi': {
    placeId: 'ChIJx5mFmlEyjgcRxtmfwkc9SNQ',
    formattedAddress: 'Teresina, PI, Brasil',
    latitude: -5.0961242,
    longitude: -42.8023065,
    types: ['locality', 'political'],
    city: 'Teresina',
    state: 'PI',
  },
  'rio-branco-ac': {
    placeId: 'ChIJ85bMirZ7f5ERPJsdfx2PuIo',
    formattedAddress: 'Rio Branco, AC, Brasil',
    latitude: -9.9740249,
    longitude: -67.8098191,
    types: ['locality', 'political'],
    city: 'Rio Branco',
    state: 'AC',
  },
  'maceio-al': {
    placeId: 'ChIJSYho1vxGAQcRU3bgQ1tyLO4',
    formattedAddress: 'Maceió, AL, Brasil',
    latitude: -9.6660417,
    longitude: -35.7352167,
    types: ['locality', 'political'],
    city: 'Maceió',
    state: 'AL',
  },
  'macapa-ap': {
    placeId: 'ChIJNxpLa-DlYY0Rlw_fMPN9NVY',
    formattedAddress: 'Macapá, AP, Brasil',
    latitude: 0.0405217,
    longitude: -51.0560957,
    types: ['locality', 'political'],
    city: 'Macapá',
    state: 'AP',
  },
  'manaus-am': {
    placeId: 'ChIJt0d2s8gbbJIRzKll959cSCs',
    formattedAddress: 'Manaus, AM, Brasil',
    latitude: -3.1190275,
    longitude: -60.0217314,
    types: ['locality', 'political'],
    city: 'Manaus',
    state: 'AM',
  },
  'salvador-ba': {
    placeId: 'ChIJvS5CUCARFgcRndtzlTaEHPc',
    formattedAddress: 'Salvador, BA, Brasil',
    latitude: -12.9777378,
    longitude: -38.5016363,
    types: ['locality', 'political'],
    city: 'Salvador',
    state: 'BA',
  },
  'fortaleza-ce': {
    placeId: 'ChIJP3hMRj9MxwcRyjdrDArGYUY',
    formattedAddress: 'Fortaleza, CE, Brasil',
    latitude: -3.7327203,
    longitude: -38.5270134,
    types: ['administrative_area_level_2', 'political'],
    city: 'Fortaleza',
    state: 'CE',
  },
  'brasilia-df': {
    placeId: 'ChIJo5Fb5Bg9WpMRf13YC2LT6CQ',
    formattedAddress: 'Brasília, DF, Brasil',
    latitude: -15.7975174,
    longitude: -47.8918881,
    types: ['administrative_area_level_2', 'political'],
    city: 'Brasília',
    state: 'DF',
  },
  'vitoria-es': {
    placeId: 'ChIJ6U43hV09uAARCdgOp35eWZc',
    formattedAddress: 'Vitória, ES, Brasil',
    latitude: -20.3196711,
    longitude: -40.3385246,
    types: ['locality', 'political'],
    city: 'Vitória',
    state: 'ES',
  },
  'goiania-go': {
    placeId: 'ChIJZwjYWL32XpMRjmfSIK0rae8',
    formattedAddress: 'Goiânia, GO, Brasil',
    latitude: -16.6868491,
    longitude: -49.2707899,
    types: ['locality', 'political'],
    city: 'Goiânia',
    state: 'GO',
  },
  'sao-luis-ma': {
    placeId: 'ChIJIW1_b_CP9gcRR96jWeQCMZg',
    formattedAddress: 'São Luís, MA, Brasil',
    latitude: -2.5306721,
    longitude: -44.2988947,
    types: ['locality', 'political'],
    city: 'São Luís',
    state: 'MA',
  },
  'cuiaba-mt': {
    placeId: 'ChIJocTJ4IGVnZMRrhr2Ts_g_KU',
    formattedAddress: 'Cuiabá, MT, Brasil',
    latitude: -15.5954142,
    longitude: -56.0925956,
    types: ['administrative_area_level_2', 'political'],
    city: 'Cuiabá',
    state: 'MT',
  },
  'campo-grande-ms': {
    placeId: 'ChIJJ58ra3LmhpQRwdKEvJ5GqPU',
    formattedAddress: 'Campo Grande, MS, Brasil',
    latitude: -20.4648517,
    longitude: -54.6218477,
    types: ['locality', 'political'],
    city: 'Campo Grande',
    state: 'MS',
  },
  'belo-horizonte-mg': {
    placeId: 'ChIJMyzPysqQpgARlznSOl55NVs',
    formattedAddress: 'Belo Horizonte, MG, Brasil',
    latitude: -19.919052,
    longitude: -43.9386685,
    types: ['locality', 'political'],
    city: 'Belo Horizonte',
    state: 'MG',
  },
  'belem-pa': {
    placeId: 'ChIJ4Wx1hK9hpJIRNUyGFQJUDVc',
    formattedAddress: 'Belém, PA, Brasil',
    latitude: -1.4563432,
    longitude: -48.501299,
    types: ['locality', 'political'],
    city: 'Belém',
    state: 'PA',
  },
  'joao-pessoa-pb': {
    placeId: 'ChIJ16OaATnorAcRNNsmbZxKQW4',
    formattedAddress: 'João Pessoa, PB, Brasil',
    latitude: -7.1188352,
    longitude: -34.8814339,
    types: ['locality', 'political'],
    city: 'João Pessoa',
    state: 'PB',
  },
  'recife-pe': {
    placeId: 'ChIJi0DllG8ZqwcRpuO9gvcOgOU',
    formattedAddress: 'Recife, PE, Brasil',
    latitude: -8.0578381,
    longitude: -34.8828969,
    types: ['locality', 'political'],
    city: 'Recife',
    state: 'PE',
  },
  'rio-de-janeiro-rj': {
    placeId: 'ChIJW6AIkVXemwARTtIvZ2xC3FA',
    formattedAddress: 'Rio de Janeiro, RJ, Brasil',
    latitude: -22.9068467,
    longitude: -43.1728965,
    types: ['locality', 'political'],
    city: 'Rio de Janeiro',
    state: 'RJ',
  },
  'natal-rn': {
    placeId: 'ChIJMQVGJqyqswcRae0P8ExAi10',
    formattedAddress: 'Natal, RN, Brasil',
    latitude: -5.7841695,
    longitude: -35.1999708,
    types: ['locality', 'political'],
    city: 'Natal',
    state: 'RN',
  },
  'porto-alegre-rs': {
    placeId: 'ChIJHctqVtKcGZURH-mHn6gRMWA',
    formattedAddress: 'Porto Alegre, RS, Brasil',
    latitude: -30.0368176,
    longitude: -51.2089887,
    types: ['locality', 'political'],
    city: 'Porto Alegre',
    state: 'RS',
  },
  'porto-velho-ro': {
    placeId: 'ChIJC1KYWWZbMpIRixnF0lry0HU',
    formattedAddress: 'Porto Velho, RO, Brasil',
    latitude: -8.7635475,
    longitude: -63.8971723,
    types: ['locality', 'political'],
    city: 'Porto Velho',
    state: 'RO',
  },
  'boa-vista-rr': {
    placeId: 'ChIJ26Sqy8oFk40RRV_XqcdlLrc',
    formattedAddress: 'Boa Vista, RR, Brasil',
    latitude: 2.8206339,
    longitude: -60.6737553,
    types: ['locality', 'political'],
    city: 'Boa Vista',
    state: 'RR',
  },
  'aracaju-se': {
    placeId: 'ChIJzSe-FUCwGgcRNjvskv00RIA',
    formattedAddress: 'Aracaju, SE, Brasil',
    latitude: -10.9265404,
    longitude: -37.0731147,
    types: ['locality', 'political'],
    city: 'Aracaju',
    state: 'SE',
  },
} satisfies Record<string, Place>;

type KnownCitySlug = keyof typeof KNOWN_CITY_PLACES;

function isKnownCitySlug(slug: string): slug is KnownCitySlug {
  return Object.hasOwn(KNOWN_CITY_PLACES, slug);
}

export function findKnownCityPlace(city: string, state: string): Place | null {
  const slug = toCitySlug(city, state);

  return slug && isKnownCitySlug(slug) ? KNOWN_CITY_PLACES[slug] : null;
}

const KNOWN_CITY_PLACES_BY_PLACE_ID = new Map<string, Place>(
  Object.values(KNOWN_CITY_PLACES).map((place) => [place.placeId, place]),
);

export function findKnownCityPlaceByPlaceId(placeId: string): Place | null {
  return KNOWN_CITY_PLACES_BY_PLACE_ID.get(placeId) ?? null;
}
